/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {NgxSpinnerService} from 'ngx-spinner';
import {NgForm} from "@angular/forms";
import {InjuryClassification} from "../../model/injury-classification";
import {InjuryClassificationService} from "../../services/injury-classification.service";
import {BaseMessageComponent} from '../../common/base-message.component';

@Component({
    selector: 'app-injury-classification',
    templateUrl: './injury-classification.component.html',
    styleUrls: ['./injury-classification.component.less'],
    standalone: false
})
export class InjuryClassificationComponent extends BaseMessageComponent implements OnInit {
  @ViewChild('documentEditForm') documentEditForm: ElementRef;
  public injuryClassifications: InjuryClassification[];

  constructor(private spinnerService: NgxSpinnerService,
              private injuryClassificationService: InjuryClassificationService,
              cdr: ChangeDetectorRef) {
    super(cdr);
  }

  ngOnInit() {
    this.getAllInjuryClassifications();
  }

  private getAllInjuryClassifications(){
    this.spinnerService.show();
    this.injuryClassificationService.getAll().subscribe(value => {
        this.injuryClassifications = value;
        this.cdr.detectChanges();
      },
      err => {
        this.spinnerService.hide();
        console.log(err);
        alert(err);
      },
      () => {
        //this.loading=false;
        this.spinnerService.hide();
      }
    );
  }

  private getChangedIndex(f:NgForm): number[] {
    let changedIndexes = [];

    Object.keys(f.controls).forEach((name) => {
      let currentControl = f.controls[name];

      if (currentControl.dirty){
        let UIindex = +name.substr(name.indexOf('__')+2);

        changedIndexes.push(UIindex);
      }

    });

    return changedIndexes;
  }

  addNew(newType: string, newDesc: string){
    this.spinnerService.show();
    var newInjuryClassification = new InjuryClassification();
    newInjuryClassification.injuryClassification = newType;
    newInjuryClassification.description = newDesc;

    this.injuryClassificationService.addInjuryClassification(newInjuryClassification).subscribe(retVal=>{
      this.getAllInjuryClassifications();
    },(error)=>{
      this.spinnerService.hide();
      if (error.status=='409')
        alert("Duplicate Value(s) found.");
      else
        alert(error.message);
    },()=>{
      this.spinnerService.hide();
      this.returnMessage = 'Adding accident crash object finished';
      setTimeout(() => {
        this.returnMessage = '';
      },2000);
    });
  }

  onSubmit(f: NgForm) {
    this.spinnerService.show();
    let count = 0;
    let array = this.getChangedIndex(f);
    var injuryClassificationIds = array.filter(function(elem, index, self) {
      return index == self.indexOf(elem);
    });
    if (injuryClassificationIds!=null && injuryClassificationIds.length>0)
    {
      injuryClassificationIds.forEach(vdi=>{
        var injuryClassificationChanged = this.injuryClassifications.find(x=>x.injuryClassificationId === vdi);
        this.injuryClassificationService.updateInjuryClassificationById(injuryClassificationChanged).subscribe(retValue=>{
          //something here?
        },(error)=>{
          this.spinnerService.hide();
          if (error.status=='409')
            alert("Duplicate Value(s) found.");
          else
            alert(error.message);
          this.returnMessage = '';
          this.getAllInjuryClassifications();
          count = 0;
        },()=>{
          count = count + 1;
          if (count>=injuryClassificationIds.length) {
            this.clearNgForm();
            count =0;
            this.spinnerService.hide();
          }
        });
      });
    }
    else{
      this.spinnerService.hide();
      alert("No changes to save.");
    }
  }

  private clearNgForm(){
    this.returnMessage = '';
    this.getAllInjuryClassifications();
    this.returnMessage = 'Updating accident crash object finished';
    setTimeout(() => {
      this.returnMessage = '';
    }, 2000);
  }

}
